import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../api/apiClient';
import { EstadoPedido, Pedido } from '../types/pedido';

export function usePedidos(estado?: EstadoPedido) {
  return useQuery({
    queryKey: ['pedidos', estado ?? 'todos'],
    queryFn: () =>
      apiFetch<Pedido[]>(`/pedidos${estado ? `?estado=${estado}` : ''}`, { autenticado: true }),
  });
}

export function usePedido(id: string) {
  return useQuery({
    queryKey: ['pedidos', 'detalle', id],
    queryFn: () => apiFetch<Pedido>(`/pedidos/${id}`, { autenticado: true }),
    enabled: Boolean(id),
  });
}

/** US-07: transiciona el estado de un pedido (BR-ORD-06/07/10/11 en el backend). */
export function useTransicionarEstadoPedido() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, estado }: { id: string; estado: EstadoPedido }) =>
      apiFetch<Pedido>(`/pedidos/${id}/estado`, {
        method: 'PATCH',
        body: { estado },
        autenticado: true,
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['pedidos'] }),
  });
}
